<app-funnel-shell>
  <div class="funnel-card">
    @if (loading()) {
      <p class="funnel-card__intro">{{ 'funnel.quiz.loading' | translate }}</p>
    }

    @if (question(); as q) {
      <div class="funnel-quiz__progress">
        {{ 'funnel.quiz.progress' | translate: { current: q.progress.current, total: q.progress.total } }}
      </div>

      <h2 class="funnel-quiz__question">{{ q.i18n_key + '.question' | translate }}</h2>

      @if (q.input === 'text') {
        <div class="funnel-quiz__text">
          <textarea
            class="funnel-quiz__textarea"
            rows="5"
            [attr.minlength]="q.min ?? null"
            [placeholder]="q.i18n_key + '.placeholder' | translate"
            [ngModel]="textValue()"
            (ngModelChange)="textValue.set($event)"
            [disabled]="busy()"
          ></textarea>
          <div class="funnel-quiz__counter">
            {{ 'funnel.quiz.char_count' | translate: { count: textValue().trim().length, min: q.min ?? 0 } }}
          </div>
          <button
            type="button"
            class="funnel-quiz__submit"
            [disabled]="busy() || textValue().trim().length < (q.min ?? 1)"
            (click)="submitText()"
          >
            {{ 'funnel.quiz.submit' | translate }}
          </button>
        </div>
      } @else {
        <div class="funnel-quiz__options">
          @for (opt of q.options; track opt.value) {
            <button
              type="button"
              class="funnel-quiz__option"
              [disabled]="busy()"
              (click)="selectAnswer(opt.value)"
            >
              {{ opt.i18n_key | translate }}
            </button>
          }
        </div>
      }
    }

    @if (error()) {
      <div class="alert alert-danger mt-3" role="alert">{{ error() }}</div>
    }
  </div>
</app-funnel-shell>
